import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from 'rxjs/Subject';
import "rxjs/Rx";
import { DataService } from "./data.service";
import { timeout, catchError, take, tap, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { AppHelper } from "../app.helper";
import { BaseHttpService } from "./base-http.service";
import { HttpClient} from "@angular/common/http";

@Injectable()
export class BusinesLogicService extends BaseHttpService {
  public gatewayUrl: string = window.location.protocol + '//' + window.location.host + '/api/';
  public socketUrl: string = (window.location.protocol == 'https:') ? 'wss://' + window.location.host + '/ws/' : 'ws://' + window.location.host + '/ws/';

  public loginError = new Subject<boolean>();
  public loginError$ = this.loginError.asObservable();

  public loginMode = 0;

  constructor(protected _blogic: HttpClient, protected _data: DataService) {
    super(_blogic, _data);
  }

  public lastQueueData: any = null;
  public lastQueueList: any = null;

  private timeout: any = null;
  private lastqueue: any = null;
  public turns: any[] = [];
  private queueTimeout: any = null;
  public turnInProgress: boolean = false;
  public queueInProgress: boolean = false;

  /* Http errors controller */
  private errorHandler(error: any): void {
    switch (error.status) {
      case 400:
        this.loginError.next(error);
        break;
      case 422:
        this.loginError.next(error);
        break;
      case 500:
        break;
      case 404:
        break;
      case 401:
        break;
      case 403:
        this.loginError.next(error);
        break;
      case 428:
        this.loginError.next(error);
        break;
      default:
        this._data.redError = true;
        break;
    }
  }

  private handleRequest<T>(observable: Observable<T>): Observable<T> {
    return observable.pipe(
      take(1),
      timeout(10000),
      tap(() => this._data.redError = false),
      catchError(error => {
        this.turnInProgress = false;
        this.queueInProgress = false;
        Observable.throw(this.errorHandler(error))
        return of(null);
      })
    )
    .map((response: any) => (response != null) ? response : null);
  }

  getOffices(): Observable<any> {
    return this.handleRequest(this.get('office'));
  }

  token(params: object = {}): Observable<any> {
    let newCredentials = {
      user: params["username"],
      pwd: params["pwd"],
      desk_id: params["desk_id"],
      application: AppHelper.APP_ID
    };
    const formData = new FormData();
    Object.keys(newCredentials).forEach(key => formData.append(key, newCredentials[key]));
    return this.handleRequest(this.post('connect/token', formData));
  }

  login(params: object = {}): Observable<any> {
    return this.handleRequest(this.post('login/auth', params));
  }

  getTicket(params: object = {}): Observable<any> {
    return this.handleRequest(this.post('office/' + this._data.session["office"] + '/turn', params));
  }

  listDesk(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + params['office_id'] + '/desk'));
  }

  configDesk(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] +'/config'));
  }

  kindListOffice(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/kindoffice/ticket'));
  }

  getPlanList(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/' + params["filter"]));
  }

  getQueueInfo(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/stat/queue'));
  }

  getDeskInfo(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/status/desk'));
  }

  getKindInfo(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/stat/kind'));
  }

  turnIsWaiting(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/turninfo'));
  }

  getSession(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/session'));
  }

  getDeskPaused(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/turn?desk_id=' + params['desk_id'] + '&cpaused=true'));
  }

  getQueueStatus(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/turn?firstqueue=' + params["queue_id"] + '&qassigned=' +params["assignedQueue"]));
  }

  getChatList(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/chat'));
  }

  getAssist(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/assist/?turn_id=' + params["turn_id"]));
  }

  getViewers(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/statusviewer/' + params["desk_id"] + '/zoneviewer'));
  }

  deskOnline(): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/online'));
  }

  checkDeskOnline(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('login/check/' + params["desk_id"]));
  }

  getAllCalls(params: object = {}): Observable<any> {
    return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/lastcall/' + params['desk_id']));
  }

  deskNotify(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/desk/' + params["desk_id"] + '/status', params));
  }

  changeTurnKind(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/kind/' + params["prekind_id"], params));
  }

  setTicketInfo(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"], params));
  }

  printTicket(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/print', params));
  }

  setTurn(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/desk', params));
  }

  recallTurn(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/recall', params));
  }

  cancelOperation(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/operation', params));
  }

  setPausedTicket(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/paused', params));
  }

  moveTurn(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params['turn_id'] + '/movement', params));
  }

  setPostpone(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/deferred/' + params["turn_id"], {}));
  }

  changePassword(params: object = {}): Observable<any> {
    return this.handleRequest(this.put('deskoperator/changepwd', params));
  }

  deleteTurn(params: object = {}): Observable<any> {
    return this.handleRequest(this.delete('office/' + this._data.session["office"] + '/turn/' + params["turn_id"]));
  }

  logout(): Observable<any> {
    let newCredential = {
      username: this._data.session["username"],
      desk_id: JSON.parse(localStorage.getItem("desk")).id,
      application: AppHelper.APP_ID,
      id: this._data.session["id"],
    };
    return this.handleRequest(this.post('logout/activity', newCredential));
  }

  ready(): Observable<any> {
    let newCredentialReady = {
      username: this._data.session["username"],
      desk_id: JSON.parse(localStorage.getItem("desk")).id,
      application: AppHelper.APP_ID,
      id: this._data.session["id"],
    };
    return this.handleRequest(this.post('activity/ready', newCredentialReady));
  }

  stop(): Observable<any> {
    let newCredentialStop = {
      username: this._data.session["username"],
      desk_id: JSON.parse(localStorage.getItem("desk")).id,
      application: AppHelper.APP_ID,
      id: this._data.session["id"],
    };
    return this.handleRequest(this.post('activity/stop', newCredentialStop));
  }

  public getOnlineList() {
    this.deskOnline().subscribe(
      (response: any) => {
        this._data.onlineDesks = response;
      });
  }

  public isDeskOnline(id: number): boolean {
    let desk = this._data.onlineDesks.find(x => x["id"].toString() === id.toString());
    return !(typeof (desk) == 'undefined');
  }

  public getTurnList(params, forced = false) {
    if (this.lastQueueData == null || params["queue_id"] != this.lastqueue  || forced) {
      this.lastqueue = params["queue_id"];
      this.turnInProgress = true;
      setTimeout(() => {
        this.turnInProgress = false;
      }, 1500);
      return this.getQueueStatus(params);
    }
    else {
      return this.getLastQueueDataObservable();
    }
  }

  public getLastQueueDataObservable() {
    return new Observable((observer) => {
      if (this.timeout == null)
        this.timeout = setTimeout(() => {
          this.lastQueueData = null;
          this.timeout = null;
        }, 5000);
      // observable execution
      observer.next(this.lastQueueData)
      observer.complete()
    });
  }

  public getQueueList(params) {
    if (this.lastQueueList == null) {
      this.queueInProgress = true;
      return this.getPlanList(params);
    }
    else {
      return this.getLastQueueObservable();
    }
  }

  public getLastQueueObservable() {
    return new Observable((observer) => {
      if (this.queueTimeout == null)
        this.queueTimeout = setTimeout(() => {
          this.lastQueueList = null;
          this.queueTimeout = null;
        }, 5000);
      // observable execution
      observer.next(this.lastQueueList)
      observer.complete()
    });
  }
}
